import AppliedCredit from "@dana/Icons/AppliedCredit";
import CreditMemos from "@dana/Icons/CreditMemos";
import OpenCredits from "@dana/Icons/OpenCredits";
import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import { fontSizes, fontWeights, lineHeights } from "@dana/MobiusOverrides/styles/typography";
import ApplicationStateDana from "@dana/Store/DanaApplicationState";
import getCreditMomos from "@dana/Store/Data/ViewCredit/Handlers/ViewCreditHandler";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconWrapper } from "@insite/mobius/Icon";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

export interface ViewCreditResultCountStyle {
    trendViewCreditCardData?: TypographyPresentationProps;
    trendViewCredit?: GridContainerProps;
    trendViewCreditItem?: GridItemProps;
    trendsTitle?: TypographyPresentationProps;
    trendViewCreditItemInner?: InjectableCss;
    viewCreditContent?: InjectableCss;
    creditType?: TypographyPresentationProps;
    viewCreditText?: TypographyPresentationProps;
}

export const viewCreditResultCountStyle: ViewCreditResultCountStyle = {
    trendsTitle: {
        variant: "h3",
        css: css`
            width: 100%;
            color: ${themeBackgrounds.darkGray};
            font-weight: ${fontWeights.regular};
            margin-bottom: 0
        `
    },
    trendViewCredit: {
        gap: 10,
    },

    trendViewCreditItem: {
        width: [12, 12, 4, 4, 4],
    },

    trendViewCreditItemInner: {
        css: css`
            background: ${themeBackgrounds.white};
            width: 100%;
            padding: 24px;
            display: flex;
            justify-content: space-between;
            border: 1px solid ${themeBackgrounds.lightGray};

            &.order-details-box {
                align-items: center;
                ${IconWrapper} {
                    flex: 1;
                    flex-shrink: 0;
                }

                .order-details-box-content {
                    flex: 2;
                }
            }
        `,
    },
    viewCreditContent: {
        css: css`
            display: flex;
            flex-direction: column;
            align-items: flex-end;

            [class*="StyledTypography"] {
                text-decoration: none;
            }
        `,
    },
    creditType: {
        color: themeBackgrounds.darkGray,
        css: css`
            margin-bottom: auto;
        `,
    },
    trendViewCreditCardData: {
        size: fontSizes.xLarge,
        lineHeight: lineHeights.xLarge,
        weight: fontWeights.bold,
    },
  
    viewCreditText: {
        css: css`
            padding: 5px;
        `,
    },
};

const mapStateToProps = (state: ApplicationStateDana) => ({
    
    viewCreditState: state.viewCreditState,
    currencyCode: state.context.session.currency?.currencyCode,

});

const mapDispatchToProps = {
    getCreditMomos
};
type Props = ResolveThunks<typeof mapDispatchToProps>  & ReturnType<typeof mapStateToProps>;

const styles = viewCreditResultCountStyle;
const ViewCreditResultCount: React.FC<Props> = ({getCreditMomos,viewCreditState,currencyCode}) => {
    return (
        <>
            <GridContainer {...styles.trendViewCredit}>
                <GridItem width={12}>
                    <Typography {...styles.trendsTitle}>{translate("Trends")}</Typography>
                </GridItem>
                <GridItem {...styles.trendViewCreditItem}>
                    <StyledWrapper {...styles.trendViewCreditItemInner}>
                        <Icon size={60} src={CreditMemos} />
                        <StyledWrapper {...styles.viewCreditContent}>
                            <Typography {...styles.creditType}>{translate("Credit Memos")}</Typography>
                            <Typography {...styles.trendViewCreditCardData}>{viewCreditState.creditsCount}</Typography>
                        </StyledWrapper>
                    </StyledWrapper>
                </GridItem>
                <GridItem {...styles.trendViewCreditItem}>
                    <StyledWrapper {...styles.trendViewCreditItemInner}>
                        <Icon size={60} src={AppliedCredit} />
                        <StyledWrapper {...styles.viewCreditContent}>
                            <Typography {...styles.creditType}>{translate('Applied Credits')} ({currencyCode})</Typography>
                            <Typography {...styles.trendViewCreditCardData}>
                              {viewCreditState.appliedCreditAmount}
                            </Typography>
                        </StyledWrapper>
                    </StyledWrapper>
                </GridItem>
                <GridItem {...styles.trendViewCreditItem}>
                    <StyledWrapper {...styles.trendViewCreditItemInner}>
                        <Icon size={60} src={OpenCredits} />
                        <StyledWrapper {...styles.viewCreditContent}>
                            <Typography {...styles.creditType}>{translate('Open Credits')} ({currencyCode})</Typography>
                            <Typography {...styles.trendViewCreditCardData}>
                                {viewCreditState.openCreditAmount}
                            </Typography>
                        </StyledWrapper>
                    </StyledWrapper>
                </GridItem>
            </GridContainer>
        </>
    );
};
export default connect(mapStateToProps, mapDispatchToProps)(React.memo(ViewCreditResultCount)); 
